import { Component, Input, OnInit } from '@angular/core';
import { Rodeo } from '../../../../../model/rodeo';
import { ExpenseCategory, rodeoExpenseItems } from '../../../../../model/rodeoExpenseItems';
import { ExpenseItemService } from '../../../../../services/ExpensesItems.service';
import { AlertMessager } from '../../../../../lib/alertMessager';
import { AlertController, LoadingController, ModalController } from 'ionic-angular';
import { NewExpenseItemComponent } from './new-expense-item.component';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'expense-items',
  templateUrl: 'expense-items.html'
})
export class ExpenseItemsComponent implements OnInit {
  @Input() rodeo: Rodeo;
  rodeoExpenseItems: rodeoExpenseItems[];
  newExpenseItem: rodeoExpenseItems = new rodeoExpenseItems();
  expenseCategoryOptions = ['Any', ...Object.values(ExpenseCategory)];
  popoverActive: boolean;
  filteredRodeoExpenseItems: rodeoExpenseItems[];
  amountFilter: string = '';
  descriptionFilter: string = '';
  expenseCategoryFilter: string = 'Any';
  searchText: string = '';
  textSearchChangeObservable: any;
  loading: any;

  constructor(
    private expenseItemService: ExpenseItemService,
    private alertMessager: AlertMessager,
    private loadingControl: LoadingController,
    private modalCtrl: ModalController,
    private alertController: AlertController
  ) {}

  ngOnInit() {
    if (this.rodeo && this.rodeo.rodeoExpenseItems) {
      this.rodeoExpenseItems = this.rodeo.rodeoExpenseItems;
      this.filteredRodeoExpenseItems = [...this.rodeoExpenseItems];
    }
  }

  openModal(expenseItemToEdit?: rodeoExpenseItems) {
    console.log(expenseItemToEdit);
    if (this.searchText === '') {
      const modal = this.modalCtrl.create(NewExpenseItemComponent, {
        expenseItem: expenseItemToEdit || this.rodeoExpenseItems,
        rodeo: this.rodeo
      }, { cssClass: 'new-expense-item' });

      modal.onDidDismiss((data) => {
        if (data) {
          this.updateRodeo(data);
        }
      });

      modal.present();
    }
  }

  updateRodeo(data) {
    const isNewItem = !this.rodeoExpenseItems.some(item => item.id === data.id);
    if (isNewItem) {
      this.rodeoExpenseItems.push(data);
      this.filteredRodeoExpenseItems = this.rodeoExpenseItems;
    } else {
      const index = this.rodeoExpenseItems.findIndex(item => item.id === data.id);
      if (index !== -1) {
        this.rodeoExpenseItems[index] = data;
        this.filteredRodeoExpenseItems = this.rodeoExpenseItems;
      }
    }
  }

  onEntrySearchChange(searchValue: string) {
    if (!this.textSearchChangeObservable) {
      Observable.create(observer => {
        this.textSearchChangeObservable = observer;
      }).debounceTime(500)
        .distinctUntilChanged()
        .subscribe((text) => {
          this.search();
        });
    }
    this.textSearchChangeObservable.next(searchValue);
  }

  search() {
    this.loading = this.loadingControl.create({
      content: 'Applying Filters...'
    });
    this.loading.present();

    this.filteredRodeoExpenseItems = [...this.rodeoExpenseItems];

    if (this.amountFilter) {
      this.filteredRodeoExpenseItems = this.filteredRodeoExpenseItems.filter(item => item.amount.toString() === this.amountFilter);
    }

    if (this.descriptionFilter) {
      this.filteredRodeoExpenseItems = this.filteredRodeoExpenseItems.filter(item =>
        item.description.toLowerCase().includes(this.descriptionFilter.toLowerCase())
      );
    }

    if (this.expenseCategoryFilter !== 'Any') {
      this.filteredRodeoExpenseItems = this.filteredRodeoExpenseItems.filter(item =>
        item.expenseCategory.toLowerCase() === this.expenseCategoryFilter.toLowerCase()
      );
    }

    this.loading.dismiss();
  }

  onDescriptionSearchChange(searchValue: string) {
    this.onEntrySearchChange(searchValue);
  }

  onAmountFilterChange(searchValue: string) {
    this.onEntrySearchChange(searchValue);
  }

  onExpenseCategorySearchChange(event: any) {
    if (event) {
      this.expenseCategoryFilter = event;
      this.search();
    }
  }

  deleteRodeoExpenseItem(expenseId: number) {
    let alert = this.alertController.create({
      title: 'Expense Rodeo Removal',
      message: 'Are you sure you want to remove this Expense Category?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {}
        },
        {
          text: 'Yes',
          handler: () => {
            this.expenseItemService.deleteExpenseItem(expenseId)
              .then(() => {
                const index = this.rodeoExpenseItems.findIndex(item => item.id === expenseId);
                if (index !== -1) {
                  this.rodeoExpenseItems.splice(index, 1);
                }
                this.filteredRodeoExpenseItems = this.rodeoExpenseItems;
              })
              .catch(error => {
                this.alertMessager.showError("Expense Item Removal Error", error);
              });
          }
        }
      ]
    });

    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/settings/expense-items/expense-items.component.ts